// Shared bits of the composite-judge mapping screens (#3417).

// 1 primary + up to 4 others (the #3416 stored shape).
export const MAX_COMPOSITE_JUDGES = 5;

// One advisory `code` -> its curated, static i18n key (the API also sends an
// English `message`, deliberately not shown so the text stays translatable).
export const ADVISORY_KEYS = {
  YOUNG_HORSE_JURY_MAX_3: "judges.compositeTab.advisoryYoungHorseJuryMax3",
};

// The other-judge ids of a stored mapping, in the order they were added. The
// API always fills `otherJudgeIds` (a row stored before #3416 reads back as
// [secondaryJudgeId]); `secondaryJudgeId` is only a fallback for a stale copy.
export function otherJudgeIdsOf(mapping) {
  if (!mapping) return [];
  if (Array.isArray(mapping.otherJudgeIds) && mapping.otherJudgeIds.length > 0) {
    return mapping.otherJudgeIds;
  }
  return mapping.secondaryJudgeId ? [mapping.secondaryJudgeId] : [];
}
